import { render, staticRenderFns } from "./waitingDep.vue?vue&type=template&id=1d38289d&scoped=true&"
import script from "./waitingDep.vue?vue&type=script&lang=js&"
export * from "./waitingDep.vue?vue&type=script&lang=js&"
import style0 from "./waitingDep.vue?vue&type=style&index=0&id=1d38289d&prod&lang=scss&scoped=true&"
import style1 from "./waitingDep.vue?vue&type=style&index=1&id=1d38289d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38289d",
  null
  
)

export default component.exports